import {
  Text,
  GreyGrey10,
  GreyGrey30,
  GreyGrey60,
  GreyGrey80,
  IconArrowRight,
  IconBarChart,
  IconCalendarDays,
  IconPageText,
  IndigoIndigo50,
  IndigoIndigo60,
  Link,
  Primary12Regular,
  Primary14SemiBold,
  Box,
  Flex
} from '@sequencehq/core-components'

interface NavigationCardProps {
  title: string
  description: string
  icon: React.ReactNode
  href: string
  testId?: string
  isComingSoon?: boolean
}

const NavigationCard = ({
  title,
  description,
  icon,
  href,
  testId,
  isComingSoon
}: NavigationCardProps) => {
  if (isComingSoon) {
    return (
      <Box
        opacity={0.7}
        p="16px"
        borderRadius="8px"
        backgroundColor={GreyGrey10}
        border="1px solid"
        borderColor={GreyGrey30}
        height="120px"
        width="400px"
        display="flex"
        flexDirection="column"
        justifyContent="space-between"
        transition="all 0.2s"
        _hover={{
          opacity: 0.9,
          borderColor: IndigoIndigo50,
          backgroundColor: GreyGrey10,
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)'
        }}
        data-testid={testId}
      >
        <Flex alignItems="center" gap="8px" mb="8px">
          <Box color={IndigoIndigo60}>{icon}</Box>
          <Text {...Primary14SemiBold} color={GreyGrey80}>
            {title}
          </Text>
        </Flex>
        <Text {...Primary12Regular} color={GreyGrey60} mb="8px" flex="1">
          {description}
        </Text>
        <Flex alignItems="center" justifyContent="space-between">
          <Text {...Primary12Regular} color={IndigoIndigo60}>
            Coming soon
          </Text>
        </Flex>
      </Box>
    )
  }

  return (
    <Box
      as={Link.Unstyled}
      to={href}
      p="16px"
      borderRadius="8px"
      backgroundColor={GreyGrey10}
      border="1px solid"
      borderColor={GreyGrey30}
      height="132px"
      width="400px"
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
      transition="all 0.2s"
      _hover={{
        borderColor: IndigoIndigo50,
        backgroundColor: GreyGrey10,
        transform: 'translateY(-2px)',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)'
      }}
      data-testid={testId}
    >
      <Flex alignItems="center" gap="8px" mb="8px">
        <Box color={IndigoIndigo60}>{icon}</Box>
        <Text {...Primary14SemiBold} color={GreyGrey80}>
          {title}
        </Text>
      </Flex>
      <Text {...Primary12Regular} color={GreyGrey60} mb="8px" flex="1">
        {description}
      </Text>
      <Flex alignItems="center" justifyContent="space-between">
        <Text {...Primary12Regular} color={IndigoIndigo60}>
          View details
        </Text>
        <IconArrowRight size={12} color={IndigoIndigo60} />
      </Flex>
    </Box>
  )
}

export const OverviewNavigationCards = {
  JournalReports: () => (
    <NavigationCard
      title="Journal reports"
      description="View detailed journal entries and revenue recognition transactions"
      icon={<IconPageText />}
      href="/revenue-recognition/journal-reports"
      testId="revrec.overview.nav.journal-reports"
    />
  ),
  DeferredRevenue: () => (
    <NavigationCard
      title="Deferred revenue"
      description="View revenue schedules and track recognition progress"
      icon={<IconCalendarDays />}
      href="/revenue-recognition/deferred-revenue?excludeFullyRecognized=true"
      testId="revrec.overview.nav.deferred-revenue"
    />
  ),
  RevenueWaterfall: () => {
    return (
      <NavigationCard
        title="Revenue waterfall"
        description="Analyze revenue flow and recognition patterns in detail"
        icon={<IconBarChart />}
        href="/revenue-recognition/revenue-waterfall"
        testId="revrec.overview.nav.revenue-waterfall"
      />
    )
  }
}
